export default __webpack_public_path__ + "static/media/feature1_6.4e8cf5a9.png";